<template>
  <div
    class="footer-contact-container"
    :class="[schema.settings.backgroundColor]"
  >
    <div class="footer-contact" :class="[schema.settings.textColor]">
      <footer-email-collection v-if="!schemaEmail.settings.hideEmail" :schema="schemaEmail">
        <slot></slot>
      </footer-email-collection>
      <div class="footer-contact__social" v-if="enabledSocial.length > 0">
        <h6
          class="footer-contact__social-title"
          :class="[schema.settings.socialTitleColor]"
        >
          {{ schema.settings.socialTitle }}
        </h6>
        <div class="footer-contact__social-list">
          <a
            class="footer-contact__social-link"
            v-for="social in enabledSocial"
            :key="social.id"
            :href="social.url"
            target="_blank"
            :aria-label="social.id"
          >
            <icon
              class="footer-contact__social-icon"
              :name="social.id"
              :fillClass="schema.settings.socialIconColor"
            ></icon>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FooterEmailCollection from '@/scripts/components/footer/FooterEmailCollection.vue';
import Icon from '@/scripts/components/basic/Icon.vue'

export default {
  name: 'FooterContactSocial',
  components: {
    Icon,
    FooterEmailCollection
  },
  props: {
    schemaEmail: Object,
    schema: Object
  },
  methods: {},
  data () {
    return {}
  },
  computed: {
    enabledSocial () {
      return this.schema.settings.socialLinks.filter(
        social => social.id !== 'none'
      )
    }
  }
}
</script>

<style lang="scss">
.footer-contact-container {
  padding: 16px 16px 12px;
  border-top: 1px solid;

  @include tablet-up {
    flex: 5;
    padding: 32px 16px 12px;
  }
}

.footer-contact {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  overflow: hidden;
  width: 100%;
  max-width: 300px;

  @include tablet-up {
    flex-wrap: nowrap;
  }

  @include mobile-only {
    margin: 0 auto;
  }

  &__contact,
  &__social {
    margin-bottom: 16px;
    flex-basis: 50%;
    flex-grow: 1;
    order: 1;

    &:nth-child(1) {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }

    .footer-content--center & {
      @include mobile-only {
        text-align: center;
      }
    }
  }

  &__contact {
    padding-right: 4px;

    @include tablet-up {
      min-width: 200px;
      padding-right: 0;
      flex-grow: 0;
    }

    &:nth-child(2) {
      order: 2;

      @include tablet-up {
        order: 1;
      }

      .footer-content--center & {
        @include mobile-only {
          order: 1;
        }
      }
    }
  }

  &__social {
    padding-left: 4px;
    text-align: center;

    @include mobile-only {
      margin-top: 40px;
    }

    @include tablet-up {
      text-align: left;
      margin-top: 20px;
    }
  }

  &__contact-title,
  &__social-title {
    margin-bottom: 12px;

    @include tablet-up {
      margin-bottom: 28px;
    }
  }

  &__social-title {
    display: none;
    @include mobile-only {
      position: absolute;
      bottom: 56px;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  &__contact-body {
    p,
    span,
    em,
    strong,
    a {
      font-size: inherit;
      line-height: inherit;
    }

    p:empty {
      margin: 4px 0;
    }
  }

  &__social-link {
    display: inline-block;
    margin-top: 4px;
    margin-bottom: 4px;
    &:not(:last-child) {
      margin-right: 24px;
    }
    @include tablet-up {
      margin-top: 8px;
      margin-bottom: 8px;
    }
  }
}
</style>
